
const en = {
  // Navigation
  "nav.about": "ABOUT",
  "nav.services": "SERVICES",
  "nav.company": "COMPANY",
  "nav.contact": "CONTACT",
  
  // About Page
  "about.hero.title": "ABOUT",
  "about.hero.subtitle": "About Us",
  "about.mission.label": "Mission",
  "about.mission.text": "Providing creators and athletes with the platform to grow, thrive, and monetize.",
  "about.mission.title1": "For Creators and Athletes,",
  "about.mission.title2": "\"A System for Monetization\" and",
  "about.mission.title3": "\"An Environment for Sustainable Growth.\"",
  "about.service.soccer.title": "Soccer Study Abroad & Development",
  "about.service.soccer.name": "Global Soccer Dreams",
  "about.service.soccer.desc": "World-class soccer development × Mentoring, Career advice",
  "about.service.creator.title": "Creator EC Platform",
  "about.service.creator.name": "Mira Closet",
  "about.service.creator.desc": "Shopping that starts from \"love.\"",
  "about.vision.title": "New Value to the World.",
  "about.vision.text": "Through our soccer study abroad and development business \"Global Soccer Dreams\" and creator EC platform \"Mira Closet,\" we operate two businesses to maximize the talents of athletes and creators and achieve sustainable growth.",
  "about.services.title": "Our Services",
  "about.services.subtitle": "Our Services",
  "about.services.sports": "SPORTS",
  "about.services.soccer.title": "Soccer Development × Study Abroad × Career Support",
  "about.services.soccer.item1": "US Soccer Study Abroad Support",
  "about.services.soccer.item2": "Individual Training Programs",
  "about.services.soccer.item3": "Online Coaching & Mentoring",
  "about.services.creatorec": "CREATOR EC",
  "about.services.creator.title": "Creator-Led Shopping Platform",
  "about.services.creator.text": "\"Buy what your favorite people love, discover brands they love, learn about fashion they love\" - a trust-based EC experience.",
  "about.contact.title": "Want to learn more about Global Soccer Dreams or Mira Closet?",
  "about.contact.text": "For questions or consultations, please feel free to contact us through the inquiry form. Our specialized staff will respond.",
  "about.contact.button": "Go to Contact Form",

  // Services Page
  "services.hero.title": "SERVICES",
  "services.hero.subtitle": "Our Services",
  "services.soccer.tag": "SOCCER PROGRAM",
  "services.soccer.title": "Global Soccer Dreams",
  "services.soccer.subtitle": "World-class Soccer Development × Study Abroad × Career Support",
  "services.soccer.content.title": "What We Offer",
  "services.soccer.content.item1": "US Soccer Study Abroad Support",
  "services.soccer.content.item2": "Individual Training Programs",
  "services.soccer.content.item3": "Online Coaching & Mentoring",
  "services.soccer.target.title": "Target",
  "services.soccer.target.text": "Athletes who want to challenge themselves in the US",
  "services.mira.tag": "CREATOR PLATFORM",
  "services.mira.title": "Mira Closet",
  "services.mira.subtitle": "Creator-Led Shopping Platform",
  "services.mira.content.title": "What We Offer",
  "services.mira.content.item1": "Creator-Exclusive Shops",
  "services.mira.content.item2": "Creator Recommendations",
  "services.mira.content.item3": "Affiliate Program",
  "services.mira.feature.title": "Features",
  "services.mira.feature.text": "\"Buy what your favorite people love, discover brands they love, learn about fashion they love\" - a trust-based EC experience.",
  "services.comparison.soccer.item1": "US Study Abroad Support",
  "services.comparison.soccer.item2": "Individual Mentoring",
  "services.comparison.soccer.item3": "Career Building Support",
  "services.comparison.soccer.item4": "Community",
  "services.comparison.mira.item1": "Exclusive Shop Setup",
  "services.comparison.mira.item2": "Recommendation Features",
  "services.comparison.mira.item3": "Affiliate Program",

  // Company Page
  "company.hero.title": "COMPANY",
  "company.hero.subtitle": "Company Overview",
  "company.info.name.label": "Company Name",
  "company.info.name.value": "Global Soccer Dreams Inc",
  "company.info.ceo.label": "CEO",
  "company.info.ceo.value": "Tessho Kobayashi",
  "company.info.business.label": "Business",
  "company.info.business.value1": "Sports Study Abroad & Development",
  "company.info.business.value2": "Creator EC",
  "company.info.address.label": "Headquarters",
  "company.info.address.value": "Miyamasuzaka Building 609, 2-19-15 Shibuya, Shibuya-ku, Tokyo",
  "company.services.title": "Our Business",
  "company.services.soccer.title": "Global Soccer Dreams",
  "company.services.soccer.subtitle": "World-class Soccer Development × Study Abroad × Career Support",
  "company.services.soccer.item1": "Overseas Soccer Study Abroad Support",
  "company.services.soccer.item2": "Individual Training Programs",
  "company.services.soccer.item3": "Online Coaching & Mentoring",
  "company.services.mira.title": "Mira Closet",
  "company.services.mira.subtitle": "Creator-Led Shopping Platform",
  "company.services.mira.item1": "Creator-Exclusive Shops",
  "company.services.mira.item2": "Creator Recommendations & Affiliate",
  "company.vision.title": "Our Vision",
  "company.vision.text": "We maximize the talents of athletes and creators, providing an environment where they can thrive on the global stage. We deliver the best support to help each person realize their dreams.",

  // Contact Page
  "contact.hero.title": "Contact",
  "contact.hero.subtitle": "Contact Us",
  "contact.form.category.title": "Please select your inquiry type",
  "contact.form.category.soccer": "Global Soccer Dreams",
  "contact.form.category.mira": "Mira Closet",
  "contact.form.category.other": "Other",
  "contact.form.name.label": "Name",
  "contact.form.name.placeholder": "John Doe",
  "contact.form.email.label": "Email Address",
  "contact.form.email.placeholder": "example@email.com",
  "contact.form.company.label": "Company Name (Optional)",
  "contact.form.company.placeholder": "Company Inc.",
  "contact.form.message.label": "Message",
  "contact.form.message.placeholder": "Please enter your message (max 500 characters)",
  "contact.form.message.note": "*Maximum 500 characters",
  "contact.form.submit": "Submit",
  "contact.form.submitting": "Submitting...",
  "contact.form.success": "Thank you for your inquiry. Your message has been sent successfully.",
  "contact.form.error": "Failed to send. Please try again.",

  // Footer
  "footer.tagline": "Individual talent into global value.",
  "footer.services": "SERVICES",
  "footer.company": "COMPANY",
  "footer.about": "About",
  "footer.companyInfo": "Company Info",
  "footer.privacy": "Privacy Policy",
  "footer.contact": "Contact",
  "footer.copyright": "© 2025 Global Soccer Dreams Inc. All rights reserved.",

  // Language
  "lang.ja": "日本語",
  "lang.en": "English"
};

export default en;
